import { HOME_PAGE_GAME_ORDER, HOME_SLIDES } from "./home.constants"

const state = {
  featurePartners: HOME_SLIDES,
  featureGames: HOME_PAGE_GAME_ORDER,
  currentFeaturePartner: null,
}
const getters = {
  featurePartners: state => {
    return state.featurePartners
  },

  featureGames: state => state.featureGames,
  currentFeaturePartner: (state, getters) => {
    if (state.currentFeaturePartner) return state.currentFeaturePartner
    return getters.featurePartners[0]
  },
}
const mutations = {
  setCurrentFeaturePartner: (state, partner) =>
    (state.currentFeaturePartner = partner),
}
const actions = {
  selectPartnerByGameKey ({ state, commit }, gameKey) {
    const partner = state.featurePartners.find(
      partner => partner.gameKey === gameKey
    )
    commit("setCurrentFeaturePartner", partner)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/home/home.module.js